import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-6 pb-6 sm:pt-10 sm:pb-12 px-4 overflow-hidden flex flex-col justify-center bg-gradient-to-b from-brand-paper-soft to-brand-paper" data-id="element-71">
      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-72">
        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 bg-brand-forest/5 border border-brand-forest/20 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-3 sm:mb-5" data-id="element-73">
          <span className="text-[10px] sm:text-xs font-bold tracking-wider text-brand-forest uppercase leading-tight" data-id="element-74">
            🌿 Manual Maestro · Edición Digital 2026
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.05
      }} className="text-xl sm:text-3xl md:text-4xl font-serif font-bold text-brand-forest leading-[1.2] mb-3 sm:mb-4" data-id="element-75">
          ¿Y si la cura para tus dolores no estuviera en la farmacia, sino en tu
          propio patio?
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-xs sm:text-base text-brand-muted leading-relaxed mb-4 sm:mb-5 max-w-xl mx-auto font-medium" data-id="element-76">
          Descubre{' '}
          <strong className="text-brand-forest" data-id="element-77">
            La Biblia de Hierbas Ancestrales
          </strong>
          : la guía definitiva para recuperar tu salud natural, eliminar la
          inflamación y sanar sin químicos. El conocimiento que las industrias
          no quieren que domines, ahora organizado en un sistema paso a paso
          para proteger a tu familia.
        </motion.p>

        {/* Product image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.15
      }} className="mb-4 sm:mb-6" data-id="element-78">
          <button onClick={scrollToPricing} className="block w-full cursor-pointer group" data-id="element-79">
            <img src="https://cdn.magicpatterns.com/uploads/wyKbz2bjRqp5LBmDXTQekE/my-project-page-1_(12).png" alt="Manual Maestro de Hierbas Ancestrales" className="w-full h-auto object-contain drop-shadow-2xl group-hover:scale-[1.02] transition-transform duration-500" data-id="element-80" />
          </button>
        </motion.div>

        {/* Main CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} data-id="element-81">
          <CTAButton className="w-full sm:w-auto sm:min-w-[300px]" variant="primary" data-id="element-82">
            SÍ, QUIERO SABER MÁS 🌿
          </CTAButton>
        </motion.div>

        {/* Trust line */}
        <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 mt-3 sm:mt-5 text-[10px] sm:text-xs text-brand-muted font-medium" data-id="element-83">
          <span data-id="element-84">🔒 Pago 100% Seguro</span>
          <span className="text-brand-muted/50" data-id="element-85">•</span>
          <span data-id="element-86">📥 Entrega Inmediata</span>
          <span className="text-brand-muted/50" data-id="element-87">•</span>
          <span data-id="element-88">🌍 Paga en tu Moneda Local</span>
          <span className="text-brand-muted/50" data-id="element-89">•</span>
          <span data-id="element-90">🛡️ Garantía Total</span>
        </div>
      </div>
    </section>;
}